export const formats = {
         fullDateTime: "dddd, MMMM Do YYYY, h:mma",
         shortDateTime: "ddd Do MMMM, h:mma",
         shortDate: "dddd Do MMM",
         shortDateYear: "dddd Do MMM YYYY",
         shortDateLongDay: "ddd Do MMMM",
         dayMonth: "Do MMM",
         time: "hh:mma",
         shortTime: "h:mma",
         consistentDateFormat: 'YYYY/MM/DD'
       };


const cc1 = ["#fafae5", "#fae5e5", "#fae5eb", "#faf5e5", "#e5f5fa", "#e5faf5", "#fae5e5", "#e5f0fa", "#ebfae5", "#fae5f5", "#e6e6fa", "#f5fae5", "#e5faeb", "#ebe5fa", "#fae5fa", "#e5ebfa", "#fae5f0", "#f5e5fa", "#f0fae5", "#faebe5", "#faf0e5", "#e5fafa", "#e5faf0", "#e5fae5", "#f0e5fa"]
const cc2 = ["#ffe699", "#ffb399", "#99ffe6", "#e6ff99", "#ff99b3", "#ccff99", "#cc99ff", "#99ff99", "#b399ff", "#99b3ff", "#ffff99", "#99ffff", "#99ccff", "#e699ff", "#ff9999", "#9999ff", "#ff99cc", "#b3ff99", "#99e6ff", "#ff99ff", "#ffcc99", "#99ffb3", "#ff99e6", "#99ffcc", "#ff9999"]
export const calendarColors = cc1.concat(cc2)